import React from 'react';
import { useAppData } from '../AppContext';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const { settings } = useAppData();

  // Respect the admin toggle
  if (!settings.whatsappEnabled && settings.whatsappEnabled !== undefined) return null;

  // Build URL: prefer full whatsapp URL from settings, fall back to phone number field
  const phone = (settings.whatsappPhone || '919820325285').replace(/\D/g, '');
  const url   = settings.whatsapp || `https://api.whatsapp.com/send?phone=${phone}`;

  // Append a default enquiry message
  const fullUrl = url.includes('text=') ? url : `${url}&text=Hello%2C%20I%20would%20like%20to%20enquire%20about%20your%20ZINGA%20products.`;

  return (
    <a
      href={fullUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-float"
      title="Chat with us on WhatsApp"
      aria-label="WhatsApp enquiry"
    >
      {/* Expanding label on hover */}
      <span className="wa-float__label">Enquire Now</span>

      {/* Green circle button */}
      <span className="wa-float__btn">
        <svg width="30" height="30" viewBox="0 0 32 32" fill="none">
          <path
            d="M16 2C8.268 2 2 8.268 2 16c0 2.49.65 4.83 1.785 6.865L2 30l7.32-1.755A13.925 13.925 0 0 0 16 30c7.732 0 14-6.268 14-14S23.732 2 16 2Z"
            fill="#fff"
          />
          <path
            d="M16 4.5C9.649 4.5 4.5 9.649 4.5 16c0 2.21.618 4.274 1.69 6.032l.22.37-1.017 3.71 3.805-.998.354.205A11.455 11.455 0 0 0 16 27.5c6.351 0 11.5-5.149 11.5-11.5S22.351 4.5 16 4.5Zm5.955 16.44c-.275.77-1.6 1.47-2.176 1.553-.53.076-1.205.107-1.944-.122a17.81 17.81 0 0 1-1.76-.65c-3.1-1.338-5.124-4.452-5.278-4.658-.153-.205-1.25-1.663-1.25-3.172s.79-2.252 1.07-2.56a1.13 1.13 0 0 1 .82-.385c.205 0 .41 0 .59.008.19.008.443-.072.692.53.254.614.862 2.123.937 2.277.076.153.127.334.026.538-.1.205-.152.334-.305.514-.152.18-.32.402-.457.54-.153.152-.312.317-.134.622.178.305.79 1.302 1.696 2.108 1.166 1.04 2.15 1.36 2.455 1.514.306.153.483.127.661-.077.18-.204.762-.89 1.968-.897.1 0 .203.008.3.025.306.05.614.178.875.307.51.256 1.633.77 1.633.77s.206.616-.07 1.364Z"
            fill="#25d366"
          />
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
